(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/ru_RU/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

// (function(d, s, id) {
//     var js, fjs = d.getElementsByTagName(s)[0];
//     if (d.getElementById(id)) return;
//     js = d.createElement(s); js.id = id;
//     js.src = "//connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v2.12&appId=" + ID_fb;
//     fjs.parentNode.insertBefore(js, fjs);
// }(document, 'script', 'facebook-jssdk'));

(function () {
    function async_load(url, id, funcName) {
        if (!gid(id)) {
            s = "script", d = document, o = d.createElement(s);
            o.type = 'text/javascript';
            o.id = o.appId = id;
            o.async = true;
            o.src = url;
            if (funcName !== undefined) {
//                o.onload = o.onreadystatechange = '"' + funcName + '"';
                console.log(funcName);
            }
            // Creating scripts on page
            x = d.getElementsByTagName(s)[0];
            x.parentNode.insertBefore(o, x);
//            console.log(x);
        }
    }
    function gid(id) {
        return document.getElementById(id);
    }


    window.onload = function () {
        // async_load("//connect.facebook.net/ru_RU/all.js", ID_fb);//facebook
        async_load("//vk.com/js/api/openapi.js?", ID_vk);//vkontakte

        if (gid("s-twitter") != null) {
            e = gid("s-twitter");
            e.setAttribute("data-lang", "ru");
            async_load("//platform.twitter.com/widgets.js", 'ID_twitter');//twitter
        }

        if (gid("s-odkl") != null) {
            !function (d, id, did, st) {
                var js = d.createElement("script");
                js.src = "//connect.ok.ru/connect.js";
                js.onload = js.onreadystatechange = function () {
                    if (!this.readyState || this.readyState == "loaded" || this.readyState == "complete") {
                        if (!this.executed) {
                            this.executed = true;
                            setTimeout(function () {
                                OK.CONNECT.insertShareWidget(id, did, st);
                            }, 0);
                        }
                    }
                };
                d.documentElement.appendChild(js);
            }(document, "s-odkl", $('meta[property="og:url"]').attr('content'), "{width:100,height:30,st:'rounded','nt' : '1', 'cm' : '1', 'ck' : '1', 'sz' : '20', 'tp' : 'ok'}");
        }

        if (gid("s-google") != null) {
            e = gid("s-google");
            window.___gcfg = {lang: 'ru'};
            async_load("https://apis.google.com/js/platform.js", 'ID_google');//google
        }

    };
    // Инициализация vkontakte
    window.vkAsyncInit = function () {
        VK.init({apiId: ID_vk});
        var vk_like_opts = {
            type: "mini",
            height: 18,
            pageUrl: $('meta[property="og:url"]').attr('content'),
            pageImage: $('meta[property="og:image"]').attr('content'),
            pageTitle: $('meta[property="og:title"]').attr('content'),
            pageDescription: $('meta[property="og:description"]').attr('content')
        };
//        console.log(vk_like_opts);
        if (gid("s-vk_like") != null) {
//            console.log($('meta[property="og:image"]').attr('content'));
            VK.Widgets.Like("s-vk_like", vk_like_opts);
        }
    };
    
    // window.fbAsyncInit = function () {
    //     FB.init({
    //         appId: ID_fb, // App ID
    //         status: true, // check login status
    //         cookie: true, // enable cookies to allow the server to access the session
    //         xfbml: true  // parse XFBML
    //     });
    // };
    window.fbAsyncInit = function() {
        FB.init({
            appId      : ID_fb,
            cookie     : true,
            xfbml      : true,
            version    : 'v2.12'
        });
        FB.AppEvents.logPageView();
    };

})();

function authInfo(response) {
    if (response.session) {
        var uid = response.session.mid;
        var sid = response.session.sid;
        var secret = response.session.secret;
        var sig = response.session.sig;
        var expire = response.session.expire;
//        var email = response.session.email;
        window.location = '//' + domain + '/soclogin/login/?network=vkontakte&uid='
                + uid + '&first_name=' + response.session.user.first_name + '&last_name='
                + response.session.user.last_name;
    }
}


function facebook_auth(response) {
    if (response.authResponse) {
        var uid = response.authResponse.userID;
        var token = response.authResponse.accessToken;

        FB.api('/me',  { locale: 'ru_RU', fields: 'name, email' }, function (response) {
            // console.log(response);
            // return false;
            if (response) {
                window.location = '//' + domain + '/soclogin/login/?network=facebook&uid=' + uid + '&token=' + token
                        + '&name=' + response.name + '&email=' + response.email;
            }
        });

    }
}

$(document).ready(function () {
    $(document).on('click', '.login_vk', function () {
//        VK.Auth.login(authInfo,4194304);
        window.location = '//' + domain + '/soclogin/login/?network=vkontakte';

        return false;
    });
    $(document).on('click', '.login_fb', function () {
        FB.login(facebook_auth, {scope: 'email'});
        return false;
    });
    $(document).on('click', '.login_twitter', function () {
        window.location = '//' + domain + '/soclogin/login/?network=twitter';

        return false;

    });
    $(document).on('click', '.login_odkl', function () {
        $.oauthpopup({
            path: '//www.odnoklassniki.ru/oauth/authorize?client_id=' + ID_ok + '&response_type=code&redirect_uri=https://' + domain + '/soclogin/login/?network=odnoklassniki',
            windowName: 'ConnectWithOAuth',
            callback: function () {
                window.location = '//' + domain + '/cabinet/personal';

            }
        });
        return false;

    });
});
